import {
  CreateMetadataService,
  IssueTypeService,
  JiraAPIConstants,
  StorageOfUniqueServices,
} from '@qality/common-service';

import API from './API';
import ServerInfoService from './ServerInfoService';

const MAX_RESULTS = 50;
const JIRA_VERSION_WHERE_CREATEMETA_IS_DEPRECATED = {
  MAJOR: 8,
  MINOR: 4,
};

export default {
  async getFields(projectKey: string) {
    const serverInfo = await ServerInfoService.getServerInfo();
    return isCreateIssueMetaDeprecated(serverInfo)
      ? getCreateIssueMetaFields(projectKey)
      : CreateMetadataService.getQAlityIssueTypeFields(projectKey);
  },
  async addTestCaseIssueTypeToProjectScheme(projectId) {
    const [testCaseIssueType] = await IssueTypeService.getTestCaseIssueTypes();

    const APIConstants = StorageOfUniqueServices.get('APIConstants');
    const schemeId = JSON.parse(
      (
        await API.request(
          APIConstants.URL_ISSUE_TYPE_SCHEMES + '?projectId=' + projectId
        )
      ).body
    );
    const scheme = JSON.parse(
      (
        await API.request(
          `/rest/api/2/issuetypescheme/${schemeId}?expand=issueTypes,defaultIssueType`
        )
      ).body
    );
    const existingIssueTypeIds: [] = scheme.issueTypes.map((it) => it.id);
    if (!existingIssueTypeIds.includes(testCaseIssueType.id)) {
      existingIssueTypeIds.push(testCaseIssueType.id);
      await API.request(`/rest/api/2/issuetypescheme/${schemeId}`, {
        type: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          name: scheme.name,
          description: scheme.description,
          defaultIssueTypeId: scheme.defaultIssueType?.id,
          issueTypeIds: existingIssueTypeIds,
        }),
      });
    }
  },
  async removeTestCaseIssueTypeFromProjectScheme(projectId: string) {
    const [testCaseIssueType] = await IssueTypeService.getTestCaseIssueTypes();
    const APIConstants = StorageOfUniqueServices.get('APIConstants');
    const schemeId = JSON.parse(
      (
        await API.request(
          APIConstants.URL_ISSUE_TYPE_SCHEMES + '?projectId=' + projectId
        )
      ).body
    );
    const scheme = JSON.parse(
      (
        await API.request(
          `/rest/api/2/issuetypescheme/${schemeId}?expand=issueTypes,defaultIssueType`
        )
      ).body
    );
    let existingIssueTypeIds: [] = scheme.issueTypes.map((it) => it.id);
    if (existingIssueTypeIds.includes(testCaseIssueType.id)) {
      existingIssueTypeIds = existingIssueTypeIds.filter(
        (id) => id !== testCaseIssueType.id
      );
      await API.request(`/rest/api/2/issuetypescheme/${schemeId}`, {
        type: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          name: scheme.name,
          description: scheme.description,
          defaultIssueTypeId: scheme.defaultIssueType?.id,
          issueTypeIds: existingIssueTypeIds,
        }),
      });
    }
  },
};

function isCreateIssueMetaDeprecated(serverInfo) {
  const [MAJOR, MINOR] = serverInfo.versionNumbers;
  return (
    MAJOR > JIRA_VERSION_WHERE_CREATEMETA_IS_DEPRECATED.MAJOR ||
    (MAJOR === JIRA_VERSION_WHERE_CREATEMETA_IS_DEPRECATED.MAJOR &&
      MINOR >= JIRA_VERSION_WHERE_CREATEMETA_IS_DEPRECATED.MINOR)
  );
}

// function uses REST API available from JIRA server 8.4.0
async function getCreateIssueMetaFields(projectKey) {
  let isLast = false;
  let startAt = 0;
  let fields = [];
  const [qalityTest] = await IssueTypeService.getTestCaseIssueTypes();
  const url =
    JiraAPIConstants.URL_GET_CREATE_ISSUE_METADATA +
    `/${projectKey}/issuetypes/${qalityTest.id}?maxResults=${MAX_RESULTS}`;

  while (!isLast) {
    const response = await API.request({
      url: `${url}&startAt=${startAt}`,
      type: 'GET',
      contentType: 'application/json',
    }).then((res) => {
      return JSON.parse(res.body);
    });

    fields = fields.concat(
      response.values.map((value) => ({
        ...value,
        key: value.fieldId,
      }))
    );

    isLast = response.isLast;
    startAt += MAX_RESULTS;
  }

  return fields;
}
